import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		display: "flex",
		flexDirection: "column",
		minWidth: 0,
		backgroundColor: tokens.colorNeutralBackground3,
		height: "100%",
		flex: "1 0 0",
		overflowY: "auto",
	},
	searchInput: {
		width: "400px",
		...shorthands.border("none"),
		backgroundColor: tokens.colorNeutralBackground1,
		color: tokens.colorNeutralForeground2BrandHover,
		height: "32px",
		marginLeft: "15px",
	},
	noSearchResultText: {
		...shorthands.margin(tokens.spacingHorizontalS),
	},
	dataScrollContainer: {
		height: "calc(100%)",
		display: "flex",
		flexDirection: "row",
		overflow: "auto",
	},
	dataContainer: {
		height: "100%",
		minWidth: "min-content",
		display: "flex",
		flexDirection: "column",
		flexGrow: 1,
	},
	dataContainerMobile: {
		marginTop: "20px",
	},
	header: {
		...shorthands.borderBottom(
			tokens.strokeWidthThin,
			"solid",
			tokens.colorNeutralStroke1
		),
		...shorthands.padding("12px", "6px", "12px", "0px"),
		color: tokens.colorNeutralForeground2,
		fontWeight: tokens.fontWeightSemibold,
	},
	rowsContainer: {
		height: "100%",
		overflowY: "auto",
		scrollbarGutter: "stable",
	},
	row: {
		...shorthands.padding("12px", "0px"),
		...shorthands.borderBottom(
			tokens.strokeWidthThick,
			"solid",
			tokens.colorNeutralBackground5
		),
		"&:hover": {
			backgroundColor: tokens.colorNeutralBackground1Selected,
			cursor: "pointer",
		},
		minWidth: "min-content",
	},
	selectedRow: {
		backgroundColor: tokens.colorNeutralBackground1Selected,
	},
	subrow: {
		width: "100%",
	},
	secondaryInfo: {
		fontSize: tokens.fontSizeBase200,
		color: tokens.colorNeutralForeground3,
		maxWidth: "450px",
		...ellipsis(),
	},
	queueColumn: {
		color: tokens.colorNeutralForeground2,
	},
	categoryColumn: {
		width: "48px",
		minWidth: "48px",
		paddingLeft: "12px",
		paddingRight: "4px",
		color: tokens.colorNeutralForeground3,
	},
	iconColumn: {
		minWidth: "100px",
		justifyContent: "flex-start",
	},
	lastColumn: {
		paddingRight: "12px",
	},
	infoMainColumn: {
		width: "93%",
		flexGrow: 1,
	},
	commonColumn: {
		minWidth: 0,
		flexGrow: 1,
		flexBasis: "150px",
		...ellipsis(),
	},
	cellContent: {
		...ellipsis(),
	},
	nameCellContent: {
		...ellipsis(),
		fontWeight: tokens.fontWeightSemibold,
	},
	headerCell: {
		display: "flex",
		alignItems: "center",
	},
	headerCellSortIndicator: {
		display: "flex",
		alignItems: "center",
	},
	spinner: {
		margin: `${tokens.spacingHorizontalM}`,
	},
	reopenEmailConversationButton: {
		padding: "0",
	},
	headerContainer: {
		justifyContent: "space-between",
		display: "flex",
		alignItems: "center",
		margin: `${tokens.spacingHorizontalL} 0px 0px 0px`,
	},
	additionalActionButton: {
		paddingRight: "0px",
		paddingLeft: "0px",
		minWidth: 0,
		height: "32px",
	},
	rightSideActions: {
		height: "32px",
		paddingRight: "5px",
	},
	expandHistoryButton: {
		border: "none",
		height: "32px",
		minWidth: "32px",
		maxWidth: "32px",
		padding: "4px 4px",
		borderRadius: "0px",
	},
	settingsPopover: {
		minWidth: "12rem",
		maxWidth: "16rem",
		maxHeight: "80%",
		padding: "0",
	},
	leftAlign: {
		textAlign: "left",
	},
	filterElement: {
		maxWidth: "100%",
		margin: "0 8px",
	},
	generalMenuSection: {
		padding: "10px 0",
	},
	typeIconColumn: {
		width: "48px",
	},
	interactionListIcon: {
		color: tokens.colorNeutralForeground3,
		"& svg": {
			color: tokens.colorNeutralForeground3,
		},
	},
	listItem: {
		backgroundColor: tokens.colorNeutralBackground3,
		"&:first-of-type": {
			borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralBackground5}`,
		},
	},
	listHeader: {
		maxWidth: "190px"
	}
});
